import { postData } from "../base.ehq.model";
import { serialize } from "./registration.serializer";
import { deserialize } from "../base.serializer";

export const createRegistrations = async (
  token: string,
  baseUrl: string,
  body: unknown,
  params?: object
) => {
  try {
    const queryPath = `${baseUrl}/registrations`;
    const serializedBody = await serialize(body);

    return await postData(token, queryPath, params, serializedBody).then(
      (res) => deserialize(res.data)
    );
  } catch (err) {
    throw new Error(err);
  }
};
